import React from 'react';
import ArrowLeftCircleIcon from '@atlaskit/icon/glyph/arrow-left-circle';
import ArrowRightCircleIcon from '@atlaskit/icon/glyph/arrow-right-circle';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlassian/jira-feature-gating';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import { messages as planCommonMessages } from '@atlassian/jira-portfolio-3-plan-increment-common';
import { RollupIcon } from '@atlassian/jira-portfolio-3-portfolio/src/common/icons';
import DependencyLegendIcon from '@atlassian/jira-portfolio-3-portfolio/src/common/view/dependency-legend-icon';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import LegendContainer from '../legend-container';
import LegendItems from '../legend-items';
import messages from '../messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import type { Props } from './types';

function SystemIconsLegend({
	intl,
	dependencySettings: { display },
}: Props & {
	intl: IntlShape;
}) {
	const legendItems = [
		{
			icon: (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.systemIcon}>
					<Lozenge>D</Lozenge>
				</div>
			),
			text: intl.formatMessage(messages.dateFieldIcon),
		},
		{
			icon: (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.systemIcon}>
					<Lozenge>S</Lozenge>
				</div>
			),
			text: intl.formatMessage(messages.sprintInferredDateIcon),
		},
		{
			icon: (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.systemIcon}>
					<Lozenge>R</Lozenge>
				</div>
			),
			text: intl.formatMessage(messages.releaseInferredDateIcon),
		},
		{
			icon: (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.systemIcon}>
					<RollupIcon label="" />
				</div>
			),
			text: intl.formatMessage(messages.rolledUpValueIcon),
		},
		{
			icon: (
				<>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.systemIcon}>
						{}
						<ArrowLeftCircleIcon label="" />
					</div>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.systemIcon}>
						{}
						<ArrowRightCircleIcon label="" />
					</div>
				</>
			),
			text: intl.formatMessage(commonMessages.datesOutsideRange),
		},
		{
			icon: <DependencyLegendIcon withWarning={false} dependencyDisplay={display} />,
			text: intl.formatMessage(commonMessages.dependency),
		},
		{
			icon: <DependencyLegendIcon withWarning dependencyDisplay={display} />,
			text: fg('dependency_visualisation_program_board_fe_and_be')
				? intl.formatMessage(commonMessages.dependencyOffTrack)
				: intl.formatMessage(commonMessages.dependencyWarning),
		},
		{
			icon: (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.systemIcon}>
					<Lozenge>{intl.formatMessage(planCommonMessages.externalLozengeShort)}</Lozenge>
				</div>
			),
			text: intl.formatMessage(messages.externalIcon),
		},
	];
	return (
		<LegendContainer
			title={intl.formatMessage(messages.systemIconsLegendHeader)}
			childrenMaxWidth="450px"
		>
			<LegendItems items={legendItems} />
		</LegendContainer>
	);
}

export default injectIntl(SystemIconsLegend);
